// Langues officielles d'Europe — codes ISO 639-1 (cnr = monténégrin, ISO 639-3)
export const UI_LANGUAGES = [
  { code: "fr", native: "Français" },
  { code: "en", native: "English" },
  { code: "de", native: "Deutsch" },
  { code: "es", native: "Español" },
  { code: "it", native: "Italiano" },
  { code: "pt", native: "Português" },
  { code: "nl", native: "Nederlands" },
  { code: "pl", native: "Polski" },
  { code: "cs", native: "Čeština" },
  { code: "sk", native: "Slovenčina" },
  { code: "sl", native: "Slovenščina" },
  { code: "hr", native: "Hrvatski" },
  { code: "sr", native: "Srpski" },
  { code: "bs", native: "Bosanski" },
  { code: "cnr", native: "Crnogorski" },
  { code: "mk", native: "Македонски" },
  { code: "sq", native: "Shqip" },
  { code: "el", native: "Ελληνικά" },
  { code: "ro", native: "Română" },
  { code: "bg", native: "Български" },
  { code: "hu", native: "Magyar" },
  { code: "et", native: "Eesti" },
  { code: "lv", native: "Latviešu" },
  { code: "lt", native: "Lietuvių" },
  { code: "fi", native: "Suomi" },
  { code: "sv", native: "Svenska" },
  { code: "da", native: "Dansk" },
  { code: "nb", native: "Norsk Bokmål" },
  { code: "is", native: "Íslenska" },
  { code: "ga", native: "Gaeilge" },
  { code: "cy", native: "Cymraeg" },
  { code: "mt", native: "Malti" },
  { code: "lb", native: "Lëtzebuergesch" },
  { code: "ca", native: "Català" },
  { code: "eu", native: "Euskara" },
  { code: "gl", native: "Galego" },
  { code: "uk", native: "Українська" },
  { code: "ru", native: "Русский" },
  { code: "tr", native: "Türkçe" },
];

// Langues parlées sélectionnables par les candidats (mêmes langues européennes)
export const LANG_CODES = UI_LANGUAGES.map((l) => l.code);

const AUTONYMS = Object.fromEntries(UI_LANGUAGES.map((l) => [l.code, l.native]));

// Nom d'une langue traduit dans la locale d'interface, fallback autonyme
export function langName(code, locale) {
  const loc = String(locale || "en").split("@")[0];
  try {
    const dn = new Intl.DisplayNames([loc], { type: "language" });
    const name = dn.of(code);
    if (name && name !== code) return name.charAt(0).toUpperCase() + name.slice(1);
  } catch { /* Intl indisponible ou code inconnu */ }
  return AUTONYMS[code] || code;
}
